import React from "react";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import ButtonWrapper from "../Button/ButtonWrapper";
import theme from "../../theme";
import { PopUpFormProps } from "../../@types/";
import classes from "*.module.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  form: {
    width: '80vw',
    margin: '0px auto'
  }
}))

const PopUpForm = (props: PopUpFormProps) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//   const handleSubmit = () => {
//     setOpen(false);
//   };

  return (
    <Box>
      <ButtonWrapper
        bgColor={theme.palette.primary.main}
        message={props.popupButtonTitle}
        onClick={handleClickOpen}
        icon={""}
      />
      <Dialog
        open={open}
        fullWidth
        className={classes.form}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {props.form}
      </Dialog>
    </Box>
  );
};

export default PopUpForm;
